/**
 * Similar to jQuery.ready()
 */
var ready = function ready(fn) {
  return (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") ? fn() : document.addEventListener("DOMContentLoaded", fn);
};

export { ready };